/**************
 Cart
 ***************/

// parse thresholds
const cartFreeShippingThreshold = parseInt(document.querySelector("#miniCartFreeShipping").getAttribute("threshold")) * 100;
const cartFreeProduct1Threshold = parseInt(document.querySelector("#miniCartFreeProduct1").getAttribute("threshold")) * 100;
const cartFreeProduct1Price = parseInt(document.querySelector("#miniCartFreeProduct1").getAttribute("price"));
const cartFreeProduct1Variant = parseInt(document.querySelector("#miniCartFreeProduct1").getAttribute("variant"));
const cartFreeProduct2Threshold = parseInt(document.querySelector("#miniCartFreeProduct2").getAttribute("threshold")) * 100;
const cartFreeProduct2Price = parseInt(document.querySelector("#miniCartFreeProduct2").getAttribute("price"));
const cartFreeProduct2Variant = parseInt(document.querySelector("#miniCartFreeProduct2").getAttribute("variant"));

// black friday promo
/*
const cartFreeProduct3Threshold = 10000;
const cartFreeProduct3Variant = 44709822169275;
*/

// open cart
async function openCart(skipDownload = false) {
    // When change product is triggered we already receive updated cart so don't download
    if (!skipDownload) {
        // fetch cart
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // Update Cart Counter On Header
    if (cart.item_count == 0) {
        document.querySelector("#headerCart").classList.remove("count");
        document.querySelector("#headerCart").removeAttribute("count")
    } else {
        document.querySelector("#headerCart").classList.add("count");
        document.querySelector("#headerCart").setAttribute("count", cart.item_count)
    }

    // reset container
    document.querySelectorAll(".miniCartBodyItem:not(.gift)").forEach(element => element.remove());

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
    } else {
        document.querySelector("#miniCartBody").classList.add("active");
        document.querySelector("#miniCartEmpty").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.add("active");
    }

    // update subtotal
    document.querySelector("#miniCartFooterCheckoutTotal").textContent = price(cart.total_price);

    // update progess bar width new
    if (cartFreeShippingThreshold <= cart.total_price && cart.total_price < cartFreeProduct1Threshold) {
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress1"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress2"), "50%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress3"), "0%");
    } else if (cartFreeProduct1Threshold <= cart.total_price && cart.total_price < cartFreeProduct2Threshold) {
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress1"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress2"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress3"), "50%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress4"), "0%");
    } else if (cartFreeProduct2Threshold <= cart.total_price) {
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress1"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress2"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress3"), "100%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress4"), "100%");
    } else {
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress1"), "0%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress2"), "0%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress3"), "0%");
        setbundleFooterProgressWidth(document.querySelector("#miniCartHeaderBarProgress4"), "0%");
    }

    // free shipping
    if (cart.total_price >= cartFreeShippingThreshold) {
        document.querySelector("#miniCartFreeShipping").classList.add("active");
    } else {
        document.querySelector("#miniCartFreeShipping").classList.remove("active");
    }

    // free product 1
    if (cart.total_price >= cartFreeProduct1Threshold) {
        document.querySelector("#miniCartFreeProduct1").classList.add("active");
        document.querySelector("#miniCartBodyItemGift1").classList.add("active");
    } else {
        document.querySelector("#miniCartFreeProduct1").classList.remove("active");
        document.querySelector("#miniCartBodyItemGift1").classList.remove("active");
    }

    // free product 2
    if (cart.total_price >= cartFreeProduct2Threshold) {
        document.querySelector("#miniCartFreeProduct2").classList.add("active");
        document.querySelector("#miniCartBodyItemGift2").classList.add("active");
    } else {
        document.querySelector("#miniCartFreeProduct2").classList.remove("active");
        document.querySelector("#miniCartBodyItemGift2").classList.remove("active");
    }

    // free product 3
    /*
    if (cart.total_price >= cartFreeProduct3Threshold) {
        document.querySelector("#miniCartBodyItemGift3").classList.add("active");
    } else {
        document.querySelector("#miniCartBodyItemGift3").classList.remove("active");
    }
     */

    // Free items message
    if (cart.total_price < cartFreeShippingThreshold) {
        document.querySelector("#miniCartHeaderFreeProductProgressMessage").innerHTML = `You are <span class="miniCartHeaderFreeProductProgressMessagePrice">${price(cartFreeShippingThreshold - cart.total_price)}</span> away from <span class="miniCartHeaderFreeProductProgressMessageLabel">${document.querySelector("#miniCartFreeShipping").getAttribute('label')}!</span>`
    } else if (cart.total_price < cartFreeProduct1Threshold) {
        document.querySelector("#miniCartHeaderFreeProductProgressMessage").innerHTML = `You are <span class="miniCartHeaderFreeProductProgressMessagePrice">${price(cartFreeProduct1Threshold - cart.total_price)}</span> away from <span class="miniCartHeaderFreeProductProgressMessageLabel">${document.querySelector("#miniCartFreeProduct1").getAttribute('label')}!</span>`
    } else if (cart.total_price < cartFreeProduct2Threshold) {
        document.querySelector("#miniCartHeaderFreeProductProgressMessage").innerHTML = `You are <span class="miniCartHeaderFreeProductProgressMessagePrice">${price(cartFreeProduct2Threshold - cart.total_price)}</span> away from <span class="miniCartHeaderFreeProductProgressMessageLabel">${document.querySelector("#miniCartFreeProduct2").getAttribute('label')}!</span>`
    } else {
        document.querySelector("#miniCartHeaderFreeProductProgressMessage").innerHTML = ``;
    }

    // ONLY chargenzen toggle if there are NO subscriptions
    /*
    if (cart.items.filter(item => item.selling_plan_allocation).length === 0) {
        document.querySelector("#miniCartFooterRefill").classList.add("active");
    } else {
        document.querySelector("#miniCartFooterRefill").classList.remove("active");
    }
     */

    // append cart
    cart.items.forEach(async function (item) {
        // remove gifts
        if (item.properties && item.properties["_free_gift"]) {
            await changeProduct({
                id: item.key,
                quantity: 0
            })
            return;
        }

        // subscription html
        function subscriptionHTML() {
            // if there are no selling plans we exit
            if (!variantToCadence[item.variant_id]) {
                return ""
            }

            // modify existing modify plan if a selling plan is already applied
            if (item.selling_plan_allocation) {
                // create open stucrture
                let HTML = `
                    <select class="miniCartBodyItemSwitch dropdown" variant="${item.variant_id}">
                        <optgroup label="Pay Full Price">
                            <option value="null">One-time only</option>
                        </optgroup>
                        <optgroup label="Subscribe and Save 15%">                            
                `;

                // generate plan options
                for (let cadence in cadenceToPlan) {
                    // determine the correct verbiage, by default we assume months
                    let label = `Delivery every ${Math.round(cadence / 30)} months`;
                    if (cadence === "30") {
                        label = "Delivery every 30 days";
                    }

                    HTML += `<option value="${cadenceToPlan[cadence]}" ${cadenceToPlan[cadence] === item.selling_plan_allocation.selling_plan.id ? "selected" : ""}>${label}</option>`;
                }

                // close select
                HTML += `
                        </optgroup>
                    </select>
                `;

                return HTML;
            }

            // upgrade option
            return ` <div class="miniCartBodyItemUpgrade button" variant="${item.variant_id}" plan="${cadenceToPlan[variantToCadence[item.variant_id]]}">Auto-Deliver & Save 20% </div> `;
        }

        function priceHTML() {
            let html = "";

            // check if final_line_price is 0, if so use original_line_price (this happesn when you add a gift and above the threashold) else use final_line_price
            if (item.final_line_price === 0) {
                html += price(item.original_line_price);
            } else {
                html += price(item.final_line_price);
            }

            html += " <s>";

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                html += price(item.selling_plan_allocation.compare_at_price * item.quantity);
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                html += price(item.original_line_price);
            }
            // check for compare at price
            else if (variantToComparePrice[item.variant_id]) {
                html += price(variantToComparePrice[item.variant_id] * item.quantity);
            }

            html += "</s>";

            return html;
        }

        document.querySelector("#miniCartBodyRebuy").insertAdjacentHTML("afterend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemTitle">${item.product_title}</div>
                    <div class="miniCartBodyItemVariant">${item.variant_title ?? ""}</div>
                    <div class="miniCartBodyItemDiscount">${item.line_level_discount_allocations.length > 0 ? item.line_level_discount_allocations[0].discount_application.title : ""}</div>
                    <div class="miniCartBodyItemQuantity">
                        <div class="miniCartBodyItemQuantityMinus">
                            <svg width="12" height="14" class="svg-inline--fa fa-minus fa-sm" aria-hidden="true" focusable="false" data-prefix="far" data-icon="minus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="" wz_dt_ref="true"><path fill="currentColor" d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"></path></svg>
                        </div>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <div class="miniCartBodyItemQuantityPlus">
                            <svg width="12" height="14" class="svg-inline--fa fa-plus fa-sm" aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z" wz_dt_ref="true"></path></svg>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="miniCartBodyItemRemove">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove" wz_dt_ref="true">
                          <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                          <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                </div>
                ${subscriptionHTML()}
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem:not(.gift)`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItemQuantity();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItemQuantity();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItemQuantity();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItemQuantity() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // Add loading
            document.querySelector("#miniCartBody").classList.add("loading");

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);

            // Remove loading
            document.querySelector("#miniCartBody").classList.remove("loading");
        }

        // switch subscription
        element.querySelector(".miniCartBodyItemSwitch")?.addEventListener("change", async function () {
            // change subscription
            cart = await changeProduct({
                id: key,
                selling_plan: parseInt(this.value)
            });

            // update active body
            await openCart(true);
        });

        // upgrade subscription
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            this.classList.add("loading");

            // change subscription
            cart = await changeProduct({
                id: key,
                selling_plan: parseInt(this.getAttribute("plan"))
            });

            // update active body
            await openCart(true);
        });
    });

    document.querySelector("#miniCart").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close cart
function closeCart() {
    document.querySelector("#miniCart").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    // start loading
    this.classList.add("loading");

    // formdata for gifts
    let formData = {
        items: []
    }

    // free product 1
    if (cart.total_price >= cartFreeProduct1Threshold) {
        formData.items.push({
            quantity: 1,
            id: cartFreeProduct1Variant,
            properties: {
                "_free_gift": true
            }
        });
    }

    // free product 2
    if (cart.total_price >= cartFreeProduct2Threshold) {
        formData.items.push({
            quantity: 1,
            id: cartFreeProduct2Variant,
            properties: {
                "_free_gift": true
            }
        });
    }

    // free product 3
    /*
    if (cart.total_price >= cartFreeProduct3Threshold) {
        formData.items.push({
            quantity: 1,
            id: cartFreeProduct3Variant,
            properties: {
                "_free_gift": true
            }
        });
    }
     */

    // add products if applicable
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // stop loading
    this.classList.remove("loading");

    // close cart
    await closeCart();

    // open upgrade
    if (window.location.skip_upgrade) {
        window.location.href = "/checkout";
    } else {
        await openUpgrade();
    }
});


// when somebody adds rebuy
document.addEventListener('rebuy.add', async function (event) {
    // re-open the cart so the new product shows up
    openCart();

    // refresh the rebuy cart which refreshes the widget
    window.Rebuy.Cart.fetchShopifyCart();
});


// Set a bundle progress item width
function setbundleFooterProgressWidth(element, width) {
    element.children[0].style = `width: ${width}`;
}


/***********************************************88 Upgrade *********************************************/

// open upgrade
async function openUpgrade() {
    // the popup only run if there are one-time products that can be upgrade

    // determine how many upgradeable products there are that can be upgraded to a subscription
    let upgradeableProducts = cart.items.filter(function (item) {
        // check if this product offers subscriptions
        let upgradeable = false;

        // that must not already have a selling plan
        if (item.selling_plan_allocation !== undefined) {
            return false;
        }

        // check if this product has a selling plan
        if (variantToCadence[item.variant_id]) {
            upgradeable = true;
        }

        return upgradeable;
    });

    // check if there are no upgradeable products
    if (upgradeableProducts.length === 0) {
        window.location.href = "/checkout";
        return;
    }

    // calculate upgrade savings
    let savings = 0;
    upgradeableProducts.forEach(function (item) {
        savings += item.original_line_price * 0.2;
    })

    // save 20% off
    document.querySelector("#upgradeATC").textContent = `SAVE - ${price(savings)}`

    document.querySelector("body").classList.add("noScroll");
    document.querySelector("#upgrade").classList.add("active");
}

// close upgrade
function closeUpgrade() {
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector("#upgrade").classList.remove("active");
    window.location.href = "/checkout";
}

// close events
document.querySelector("#upgrade").addEventListener("click", function (e) {
    if (e.target === this) {
        closeUpgrade();
    }
});
document.querySelector("#upgradeNo").addEventListener("click", function () {
    closeUpgrade();
});
document.querySelector("#upgradeClose").addEventListener("click", function () {
    closeUpgrade();
});

// upgrade event listener
document.querySelector("#upgradeATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // upgrade each product
    for (let i = 0; i < cart.items.length; i++) {
        if (variantToCadence[cart.items[i].variant_id]) {
            await changeProduct({
                id: cart.items[i].key,
                quantity: cart.items[i].quantity,
                selling_plan: cadenceToPlan[variantToCadence[cart.items[i].variant_id]],
                properties: {
                    "_upgrade": true
                }
            });
        }
    }

    // close
    closeUpgrade();

    // stop loading animation
    this.classList.remove("loading");
});